import {useCallback} from 'react';
import {getNorafUpdates} from 'api/agentNoraf';
import {useGetTokens} from 'services/auth';

export const useGetNorafUpdates = () => {
  const getTokens = useGetTokens();

  return useCallback(
    (page?: number, size?: number, sort?: string, mock?: boolean) => {
      return getNorafUpdates(getTokens, page, size, sort, mock);
    },
    [getTokens],
  );
};
